<template>
  <div class="iframe-container">
    <iframe :src="pageUrl" frameborder="0" height="100%" width="100%"></iframe>
  </div>
</template>
<script>
import { getToken } from '@/utils/auth'
import {recordSdLoginNumber} from '@/api/user'
  export default {
    watch: {
      "$route": {
        handler(n) {
          let stdPagePath = n.meta.stdPagePath
          let query = {
            source: 'jiufang',
            token: getToken()
          }
          if (n.query.stdParams || n.query.stdQuery) {
            if (n.query.stdParams) {
              let stdParams = JSON.parse(n.query.stdParams)
              stdPagePath += `/${Object.values(stdParams).join('/')}?${this.splitQueryParams(query)}`
            }
            if (n.query.stdQuery) {
              query = Object.assign(JSON.parse(n.query.stdQuery), query)
              stdPagePath += `?${this.splitQueryParams(query)}`
            }
          } else {
            stdPagePath += `?${this.splitQueryParams(query)}`
          }
          this.pageUrl = process.env.VUE_APP_STD_URI + stdPagePath
          this.recordLogin()
        },
        deep: true,
        immediate: true
      }
    },
    data() {
      return {
        pageUrl: ''
      }
    },
    methods: {
      splitQueryParams(params) {
        console.log(params, 'params')
        let tempParams = []
        if (Object.keys(params).length <= 0) return tempParams

        for (let key in params) {
          tempParams.push(`${key}=${params[key]}`)
        }

        return tempParams.join("&")
      },
      recordLogin(){
        const params = {
          customerId: this.$store.getters.userInfo.id,
          clientType: 2, //1 客户端 2std
        }
        recordSdLoginNumber(params)
      }

    }
  }

</script>
<style lang="scss" scoped>
  .iframe-container {
    width: 100%;
    height: calc(100vh - 110px);
  }

</style>
